module.exports = __webpack_public_path__ + "img/confirmIcon.9d60b10e.svg";